import clsx from "clsx";
import AuthTitle from "../AuthTitle";
import SignUpForm from "../SignUpForm";
import ThirdPartyAuth from "../ThirdPartyAuth";
import getDomainNameFromURL from "../../helpers/getDomainNameFromURL";

import { memo } from "react";
import { AuthenticationOptionsT } from "models/models";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./signUpOrg.module.scss";

interface SignUpOrgI extends React.HTMLAttributes<HTMLDivElement> {
  authOptions?: AuthenticationOptionsT;
  onSubmitSuccess?: (...args: unknown[]) => void;
  onSubUserSubmitSuccess?: (email: string) => void;
}

const SignUpOrg = memo((props: SignUpOrgI) => {
  const {
    className,
    authOptions,
    onSubmitSuccess,
    onSubUserSubmitSuccess,
    ...restProps
  } = props;

  const { getTextByKey } = useContent();

  return (
    <div className={clsx(styles.wrapper, className)} {...restProps}>
      <AuthTitle type="sign-up" />
      {(authOptions ? authOptions?.Email : true) ? (
        <SignUpForm
          onSubmitSuccess={onSubmitSuccess}
          onSubUserSubmitSuccess={onSubUserSubmitSuccess}
        />
      ) : (
        <p className={styles.subUserJoinHint}>
          {getTextByKey("sub-user-join-hint").replace(
            "%domain%",
            getDomainNameFromURL()
          )}
        </p>
      )}
      <ThirdPartyAuth
        showOrDivider={authOptions ? authOptions?.Email : true}
        orgAuthOptions={authOptions}
        onSubmitSuccess={onSubmitSuccess}
        onSubUserSubmitSuccess={onSubUserSubmitSuccess}
      />
    </div>
  );
});

export default SignUpOrg;
